var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"max-height":"100px"}},[_c('v-container',{staticClass:"mt-8"},[_c('v-alert',{staticClass:"mx-2 mt-4",attrs:{"border":"bottom","colored-border":"","type":"warning","elevation":"2"}},[_vm._v(" این پروژه در حال حاضر،‌در مرحله پیش ثبت نام بیلبورد است. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }